import React, { Fragment, useContext, useEffect, useState } from "react";

import { TransactionGetGallery } from "../Services/Transactions";

import { LoadingContext, MainContext } from "../Context";

import { GalleryType } from "../Structures";

import { formatDate, formatText } from "../Utils";

import { PageHeader } from "../Components/Common";
import { Empty, Tag } from "../Components/Base";
import { Link } from "react-router-dom";

const Gallery = () => {
  const { setting } = useContext(MainContext);
  const { loading, setLoading } = useContext(LoadingContext);

  // ==============================================================

  const [albums, setAlbums] = useState<GalleryType[]>([]);

  // ==============================================================

  useEffect(() => {
    setLoading(true);
    TransactionGetGallery()
      .then(({ data: res }) => {
        if (res.transaction_status) {
          setAlbums(res.data || []);
        }
      })
      .finally(() => setLoading(false));
  }, []);

  // ==============================================================

  return (
    <Fragment>
      <PageHeader src={setting.gallery_banner} title="گالری" />
      <Empty
        data={albums}
        isLoading={loading}
        description="درحال حاضر آلبومی وجود ندارد"
      >
        <section className="position-relative pt-0">
          <div className="container" data-sticky-container>
            <div className="row">
              {albums.map((album: GalleryType) => (
                <div key={album.id} className="col-lg-6">
                  <Link
                    to={`/gallery/${album.id}/`}
                    className="card shadow border-1 p-2 mb-4"
                  >
                    <div className="row">
                      <div className="col-md-5">
                        <img
                          style={{ height: 150 }}
                          className="rounded-3 w-100 object-fit-cover"
                          src={album.thumbnail}
                          alt={album.title}
                        />
                      </div>
                      <div className="col-md-7 mt-3 mt-md-0">
                        {album.categories.map((tag) => (
                          <Tag key={tag.id} tag={tag} />
                        ))}
                        <h4>
                          <span className="btn-link stretched-link">
                            {album.title}
                          </span>
                        </h4>

                        <p>{formatText(album.description, 200)}</p>

                        <ul className="nav nav-divider align-items-center d-none d-sm-inline-block">
                          <li className="nav-item">
                            {formatDate(album.create_date)}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </section>
      </Empty>
    </Fragment>
  );
};

export default Gallery;
